/** Tiện ích hex nhẹ — cùng công thức `banhang-frontend`. */

export function normalizeHex(hex: string): string {
  let h = hex.trim().replace('#', '')
  if (h.length === 3) {
    h = h
      .split('')
      .map((c) => c + c)
      .join('')
  }
  if (h.length !== 6 || !/^[0-9a-fA-F]+$/.test(h)) return '#0070f4'
  return `#${h.toLowerCase()}`
}

export function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
  const h = normalizeHex(hex).slice(1)
  return {
    r: parseInt(h.slice(0, 2), 16),
    g: parseInt(h.slice(2, 4), 16),
    b: parseInt(h.slice(4, 6), 16),
  }
}

export function rgbToHex(r: number, g: number, b: number): string {
  const c = (n: number) =>
    Math.max(0, Math.min(255, Math.round(n)))
      .toString(16)
      .padStart(2, '0')
  return `#${c(r)}${c(g)}${c(b)}`
}

/** Trộn a → b, t=0 chỉ a, t=1 chỉ b. */
export function mixHex(a: string, b: string, t: number): string {
  const A = hexToRgb(a)
  const B = hexToRgb(b)
  if (!A || !B) return normalizeHex(a)
  const u = Math.max(0, Math.min(1, t))
  return rgbToHex(
    A.r + (B.r - A.r) * u,
    A.g + (B.g - A.g) * u,
    A.b + (B.b - A.b) * u,
  )
}

/** Đậm dần về đen theo ratio 0..1. */
export function darkenHex(hex: string, ratio: number): string {
  const x = hexToRgb(hex)
  if (!x) return normalizeHex(hex)
  const f = Math.max(0, Math.min(1, 1 - ratio))
  return rgbToHex(x.r * f, x.g * f, x.b * f)
}
